import { gql, uploadFile } from "./api";

interface ListUsersInput {
  uuid: String;
  token: String;
  organization_id: Number | undefined;
}

interface GetUserInput {
    uuid: String;
    token: String;
    user_uuid: String | undefined;
}

interface CreateUserInput {
    uuid: string;
    token: String;
    firstname: string;
    lastname: string;
    email: string;
    password: string | null;
    phone: string;
    country: string;
    address_street_city: string;
    postal_code: string;
    job_title: string;
    organization_id: number | string | undefined;
    limited: boolean;
    language: string | undefined | boolean | any;
}

interface EditUserInput {
    uuid: string;
    token: String;
    user_uuid: String | undefined;
    firstname: string;
    lastname: string;
    password: string | null;
    phone: string;
    country: string;
    address_street_city: string;
    postal_code: string;
    job_title: string;
    language: string | undefined | boolean | any;
}

export interface UploadBulkUsersInput {
  file: File;                  
  uuid: string;               
  token: string;               
  organization_id: number | string | undefined;     
}

export const EditUser = async({
    uuid, token, user_uuid, firstname, lastname,
    password, phone, country, address_street_city,
    postal_code, job_title, language
}: EditUserInput) => {

    const response = await gql({
        query: 
            `mutation EditUser {
                    editUser(
                        userEditInput: {
                            uuid: "${uuid}"
                            token: "${token}"
                            user_uuid: "${user_uuid}"
                            language: "${language}"
                            firstname: "${firstname}"
                            lastname: "${lastname}"
                            password: "${password}"
                            job_title: "${job_title}"
                            phone: "${phone}"
                            country: "${country}"
                            address_street_city: "${address_street_city}"
                            postal_code: "${postal_code}"
                        }
                     ){
                    user {
                        uuid
                        email
                        firstname
                        lastname
                        password
                        status
                        organization_id
                        role
                        level
                        exp
                        settings
                        job_title
                        phone
                        country
                        address_street_city
                        postal_code
                        photo
                    }
                }
            }`,
            returnFunc: 'editUser'
    })

    return response.user

}



export const CreateUser = async({
    uuid, token, firstname, lastname, email,
    password, phone, country, address_street_city,
    postal_code, job_title, organization_id, limited,
    language
}: CreateUserInput) => {

    const response = await gql({
        query: 
            `mutation CreateUser {
                    createUser(
                        userInput: {
                            uuid: "${uuid}"
                            token: "${token}"
                            language: "${language}"
                            limited: ${limited}
                            email: "${email}"
                            firstname: "${firstname}"
                            lastname: "${lastname}"
                            password: "${password}"
                            status: 1
                            organization_id: ${organization_id}
                            role: 1
                            job_title: "${job_title}"
                            level: 1
                            exp: 0
                            phone: "${phone}"
                            country: "${country}"
                            address_street_city: "${address_street_city}"
                            postal_code: "${postal_code}"
                            photo: 0
                        }
                    ) {
                        uuid
                        token
                        email
                        firstname
                        lastname
                        status
                        organization_id
                        role
                        job_title
                        phone
                        country
                        address_street_city
                        postal_code
                        photo
                        language
                    }
        }`,
        returnFunc: 'createUser'
    })

    return response.user

}

export const GetUser = async ({
    uuid, token, user_uuid
}: GetUserInput) => {
    const response = await gql({
        query: `
            mutation GetUser {
                    getUser(
                        getUserInput: {
                            uuid: "${uuid}"
                            token: "${token}"
                            user_uuid: "${user_uuid}"
                        }
                    ) {
                        user {
                            uuid
                            email
                            firstname
                            lastname
                            level
                            exp
                            job_title
                            phone
                            country
                            address_street_city
                            postal_code
                            photo
                            settings
                        }
                    }
            }`, 
        returnFunc: 'getUser'
    })

    return response.user;

}


export const ListUsers = async ({
  uuid, 
  token,
  organization_id
}: ListUsersInput) => {
    const response = await gql(
        {
            query: `
                mutation ListUsers {
                    listUsers(
                        userListInput: {
                            uuid: "${uuid}"
                            token: "${token}"
                            organization_id: ${organization_id}
                        }
                    ) {
                        users {
                            uuid
                            email
                            firstname
                            lastname
                            status
                            organization_id
                            role
                            level
                            exp
                            job_title
                            phone
                            country
                            address_street_city
                            postal_code
                            photo
                        }
                    }
                }
          `,
          returnFunc: 'listUsers'
        }
    );

  return response.users;
};



export const UploadBulkUsers = async ({
  file,
  uuid,
  token,
  organization_id,
}: UploadBulkUsersInput): Promise<any> => {
  if (!file) throw new Error("No file provided for bulk upload");

    // TODO: Make Work on separate upload system
    /*const formData = new FormData();
    formData.append('file', file);

    formData.append('file', file);
    formData.append('uuid', uuid);
    formData.append('token', token);

    const response = await uploadFile({
        url: '/user/bulk/upload',
        formData,
    });

  return response;*/

  return []
};



